import React, { useState, useEffect, useRef } from "react";
import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";

const BuyerInput = ({
  value,
  onChange,
  buyerOptions,
  disabled,
  scrollLeft = 0,
}) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const divRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef]);

  useEffect(() => {
    const selectedOption = buyerOptions.find(
      (option) => option.value === value
    );
    setInputValue(selectedOption ? selectedOption.name : value || "");
  }, [value, buyerOptions]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    onChange(newValue);
    setShowDropdown(true);
  };

  const handleSelectChange = (option) => {
    setInputValue(option ? option.label : "");
    onChange(option ? option.value : "");
    setShowDropdown(false);
  };

  return (
    <div ref={inputRef} className="buyer-input-container">
      <input
        type="text"
        style={{ maxWidth: "100%", opacity: disabled ? 0.5 : 1 }}
        placeholder={t("TYPE_HERE")}
        value={inputValue}
        onChange={(e) => handleInputChange(e.target.value)}
        onFocus={() => setShowDropdown(true)}
        disabled={disabled}
      />
      {showDropdown && (
        <div className="w-100 buyerinput-dropdown" ref={divRef}>
          <ReactSelect
            className="select_buyer"
            options={buyerOptions.map((option) => ({
              value: option.value,
              label: option.name,
            }))}
            value={inputValue ? { value: value, label: inputValue } : null}
            onChange={handleSelectChange}
            onInputChange={(newValue) => handleInputChange(newValue)}
            isSearchable
            isClearable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: "200px",
                overflowY: "auto",
              }),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default BuyerInput;
